import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { getPremiumColorGradient } from 'uiKit/Theme/themeUtils';
import { COLOR_FREEMIUM } from 'uiKit/Theme/const';

import { FontSize, getFontSize, getBackground } from './premiumLabelUtils';

interface IUserPremiumLabelStylesProps {
  size: FontSize;
  hasGradientBackground?: boolean;
  hasFlatBackground?: boolean;
}

export const usePremiumLabelStyles = makeStyles<IUserPremiumLabelStylesProps>()(
  (theme: Theme, { hasFlatBackground, hasGradientBackground, size }) => {
    const fontWeight = size === 's' || size === 'xs' ? 500 : 700;
    const fontSize = getFontSize(size, theme);

    return {
      premiumLabel: {
        padding: size === 's' ? theme.spacing(0.5, 1) : 0,
        borderRadius: theme.shape.borderRadiusSm,
        background: getBackground(
          theme,
          hasGradientBackground,
          hasFlatBackground,
        ),
      },
      preLabel: {
        fontWeight: fontWeight,
        fontSize: fontSize,
        color: COLOR_FREEMIUM,
        padding: theme.spacing(1),
        lineHeight: 1,
      },
      divider: {
        fontWeight: fontWeight,
        fontSize: fontSize,
        color: theme.palette.text.disabled,
        paddingRight: theme.spacing(1),
        lineHeight: 1,
        [theme.breakpoints.down('xs')]: {
          margin: theme.spacing(0, 1),
        },
      },
      gradient: {
        color: hasGradientBackground ? 'white' : getPremiumColorGradient(theme),
        background: hasGradientBackground
          ? 'transparent'
          : getPremiumColorGradient(theme),
        WebkitBackgroundClip: hasGradientBackground ? 'unset' : 'text',
        WebkitTextFillColor: hasGradientBackground ? 'unset' : 'transparent',
        letterSpacing: '0.01em',
        fontWeight: fontWeight,
        fontSize: fontSize,
        lineHeight: 1,
        padding: theme.spacing(1),
      },
      noPaddingLeft: {
        paddingLeft: 0,
      },
    };
  },
);
